import { render, staticRenderFns } from "./GoodList.vue?vue&type=template&id=62661c1c&scoped=true&"
import script from "./GoodList.vue?vue&type=script&lang=ts&"
export * from "./GoodList.vue?vue&type=script&lang=ts&"
import style0 from "./GoodList.vue?vue&type=style&index=0&id=62661c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62661c1c",
  null
  
)

export default component.exports